import 'bootstrap/dist/css/bootstrap.min.css';
import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";

import Navbar from "./components/Navbar";

class App extends Component {

  constructor() {
    super();

    const client_png = window.location.hostname.split('.')[0] + '.png';
    const logo = window.location.hostname.split('.')[0] === 'citizenengagement' ? 'iamgis.png' : client_png;
    console.log('logo', logo);
    this.state = {
      logo: logo
    };
  }

  render() {
    return (
      <Router>
        <div className="app-container">
          <img src={this.state.logo} alt="customer logo" height="60px" className='customer_logo mb-4' />
          <div className="hero-section">
            <div className="hero-content">
              <h3 className="hero-title">Help improve your community!</h3>
            </div>
            <div className="hero-overlay"></div>
          </div>
          <div className="main-content mx-4">
            <Navbar></Navbar>
          </div>
          <footer className="footer pt-3 bg-white">
            <p>Powered by <img src="iamgis.png" alt="iamgis logo" height="30px" className="mb-1" /></p>
          </footer>
        </div>
      </Router>
    );
  }
}

export default App;